/* eslint-disable max-statements */
/* eslint-disable max-len */
import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {Card, Dropdown, Grid, Input, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import DatePicker from 'react-datepicker';
import {dateFormatPicker, noTimeZoneShortISODate, reverseShortDate} from '../../../common/constants/datesFormat';
import moment from 'moment';

const HeaderForm = (props) => {
  const [errorOrderNumber, setErrorOrderNumber] = useState(false);

  const {headerValues, setHeaderValues} = props;
  const mapProvidersToDropdownList = (list) => {
    return list.map((item) => {
      return (
        item.identification !== 'S/N' &&
        item.identification !== '.' &&
        item.identification
      ) && {
        'key': item.identification,
        'value': item.identification,
        'text': item.referenceCode ? `${item.referenceCode} - ${item.name}` : item.name,
      };
    });
  };

  const allProviders = props.listProviders ? mapProvidersToDropdownList(props.listProviders) : null;

  const setHeaderValuesHandler = (name, value) => {
    setHeaderValues({
      ...headerValues,
      [name]: value,
    });
  };

  const valdidDate = (year, month) => {
    if (year && month) {
      return moment(`01/${month}/20${year}`, reverseShortDate).isValid();
    }
    return false;
  };

  const foundOrigin = (listOrigin, origin) => listOrigin.find((item) => item.country_equivalence === origin.toUpperCase());
  const getLastDayOfMonth = (year, month) => moment(`01/${month}/${year}`, reverseShortDate)
    .endOf('month')
    .format('DD');
  const sumMonthsToDate = (date, months) => moment(date, reverseShortDate).add(months, 'months')
    .format(reverseShortDate);

  const getEquivalentOrderNumber = (listOrigins, orderNumber) => {
    const element = listOrigins.find((item) => item.country === orderNumber.substring(4, 6).toUpperCase());
    if (element && element.country_equivalence) {
      return orderNumber.substring(0, 4) + element.country_equivalence;
    }
    return orderNumber;
  };
  
  const autoCompleteByOrderNumber = (e, headerObject = null) => {
    setHeaderValues({
      ...headerValues,
      'orderNumber': e.target.value.toUpperCase(),
    });

    if (e.target.value.length < 6) {
      return;
    }
    
    const yearValue = `20${(e.target.value).substring(0, 2)}`;
    let monthValue = (e.target.value).substring(2, 4);
    const origin = (e.target.value).substring(4, 6);
    if (!valdidDate(yearValue, monthValue)) {
      setErrorOrderNumber(true);
      return;
    }
    monthValue = parseInt(monthValue, 10);
    const found = foundOrigin(props.listOrigins, origin);
    if (found) {
      setErrorOrderNumber(false);
      const summedMonth = parseInt(found.arrival_time, 10) || 0;
      const lastDayShipment = getLastDayOfMonth(yearValue, monthValue);
      const shipmentDate = headerObject.shipmentDate ? moment(headerObject.shipmentDate, noTimeZoneShortISODate).format(reverseShortDate) :
        `${lastDayShipment}/${monthValue}/${yearValue}`;
      const arrivalDate = headerObject.arrivalDate ?
        moment(headerObject.arrivalDate, noTimeZoneShortISODate).format(reverseShortDate) :
        sumMonthsToDate(shipmentDate, summedMonth);
      
      setHeaderValues({
        ...headerValues,
        'dateOfShipment': headerObject.shipmentDate ?
          moment(headerObject.shipmentDate, noTimeZoneShortISODate).format(reverseShortDate) :
          shipmentDate,
        'orderNumber': e.target.value.toUpperCase(),
        'origin': found.country,
        'dateOfArrival': arrivalDate,
        'nlLines': headerObject ? headerObject.nl : 0,
        'flLines': headerObject ? headerObject.fl : 0,
        'dpLines': headerObject ? headerObject.dp : 0,
        'dnLines': headerObject ? headerObject.dn : 0,
        'deLines': headerObject ? headerObject.de : 0,
        'total': headerObject ? headerObject.total : 0,
        'year_model': headerObject ? headerObject.model_year : '',
        'provider': headerObject ? headerObject.supplier : '',
        'originText': headerObject.originText,
      });
      return;
    }
    setErrorOrderNumber(true);
  };

  useEffect(() => {
    if (!!props?.originsAllData?.resultHeader?.orderNumber && props.listOrigins) {
      const orderNumberEquivalent = getEquivalentOrderNumber(
        props.listOrigins,
        props?.originsAllData?.resultHeader?.orderNumber
      );
      autoCompleteByOrderNumber(
        {'target': {'value': orderNumberEquivalent}},
        props.originsAllData.resultHeader
      );
    }
  }, [props.originsAllData, props.listOrigins]);


  const updateShipmentDate = (shipmentDate) => {
    const originOrder = (headerValues.orderNumber).substring(4, 6);
    const originFound = foundOrigin(props.listOrigins, originOrder);
    if (originFound) {
      setErrorOrderNumber(false);
      const summedMonth = parseInt(originFound.arrival_time, 10) || 0;
      const shipmentDateTemp = moment(shipmentDate).format(reverseShortDate);
      const arrivalDateTemp = sumMonthsToDate(shipmentDateTemp, summedMonth);
      setHeaderValues({
        ...headerValues,
        'dateOfShipment': shipmentDateTemp,
        'dateOfArrival': arrivalDateTemp,
      });
    }
  };

  return (
    <Card raised fluid className='small-container'>
      {!props.originsAllData || props.loading ?
        <Loader active inline='centered' className='custom-loader' /> :
        <Grid columns={3} divided className='no-space' textAlign='left'>
          <Grid.Row>
            <Grid.Column>
              <Grid columns={2}>
                <Grid.Row>
                  <Grid.Column width={15}>
                    <h3>Datos de la orden</h3>
                  </Grid.Column>
                  <Grid.Column width={7}>
                    <h4>Pedido</h4>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <Input
                      error={errorOrderNumber}
                      value={headerValues.orderNumber}
                      onChange={autoCompleteByOrderNumber}
                      className='header-input disabled-custom custom-input-small'
                      disabled
                    />
                  </Grid.Column>
                  <Grid.Column width={7}>
                    <h4>Orígen</h4>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <Input
                      error={errorOrderNumber}
                      value={headerValues.originText}
                      onChange={autoCompleteByOrderNumber}
                      className='header-input disabled-custom custom-input-small'
                      disabled
                    />
                  </Grid.Column>
                  <Grid.Column width={7}>
                    <h4>Proveedor</h4>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <Dropdown
                      placeholder='Seleccionar proveedor'
                      fluid
                      search
                      selection
                      value={headerValues.provider}
                      onChange={(e, {value}) => setHeaderValuesHandler('provider', value)}
                      options={allProviders}
                      className='header-input custom-selector-small supplier-selector-orders'
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column stretched className='header-top-space'>
              <Grid columns={2}>
                <Grid.Row>
                  <Grid.Column width={7}>
                    <h4>Fecha de embarque</h4>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <DatePicker
                      placeholderText='Seleccione la fecha'
                      className='tcc-datepicker header-input disabled-custom custom-input-small'
                      showYearDropdown
                      selected={headerValues.dateOfShipment ?
                        moment(headerValues.dateOfShipment, reverseShortDate).toDate() :
                        null
                      }
                      dateFormat={dateFormatPicker}
                      customInput={<Input readOnly icon='calendar' size='small' />}
                      onChange={(value) => updateShipmentDate(value)}
                      locale='es'
                    />
                  </Grid.Column>
                  <Grid.Column width={7}>
                    <h4>Fecha de arribo</h4>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <DatePicker
                      placeholderText='Seleccione la fecha'
                      className='tcc-datepicker header-input disabled-custom custom-input-small'
                      showYearDropdown
                      selected={headerValues.dateOfArrival ?
                        moment(headerValues.dateOfArrival, reverseShortDate).toDate() :
                        null
                      }
                      dateFormat={dateFormatPicker}
                      customInput={<Input readOnly icon='calendar' size='small' />}
                      onChange={(value) => setHeaderValuesHandler('dateOfArrival', moment(value).format(reverseShortDate))}
                      locale='es'
                    />
                  </Grid.Column>
                  <Grid.Column width={7}>
                    <h4>Año modelo</h4>
                  </Grid.Column>
                  <Grid.Column width={8}>
                    <Input
                      value={headerValues.year_model}
                      onChange={(e, {value}) => !isNaN(value) && setHeaderValuesHandler('year_model', value)}
                      className='header-input custom-input-small'
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
            <Grid.Column>
              <Grid columns={4} stretched className='header-top-space'>
                <Grid.Row className='header-lines'>
                  <Grid.Column>
                    <h4>Normal</h4>
                  </Grid.Column>
                  <Grid.Column>
                    <h5>{headerValues.nlLines}</h5>
                  </Grid.Column>
                  <Grid.Column>
                    <h4>Flotante</h4>
                  </Grid.Column>
                  <Grid.Column>
                    <h5>{headerValues.flLines}</h5>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className='header-lines'>
                  <Grid.Column>
                    <h4>Diplomático Extranjero</h4>
                  </Grid.Column>
                  <Grid.Column>
                    <h5>{headerValues.deLines}</h5>
                  </Grid.Column>
                  <Grid.Column>
                    <h4>Diplomático Nacional</h4>
                  </Grid.Column>
                  <Grid.Column>
                    <h5>{headerValues.dnLines}</h5>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row className='header-lines'>
                  <Grid.Column>
                    <h4>Depósito</h4>
                  </Grid.Column>
                  <Grid.Column>
                    <h5>{headerValues.dpLines}</h5>
                  </Grid.Column>
                  <Grid.Column >
                    <h3>Total</h3>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <h4>{headerValues.total}</h4>
                  </Grid.Column>
                </Grid.Row>
              </Grid>

            </Grid.Column>
          </Grid.Row>
        </Grid>
      }
    </Card>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.manageOrders.loading,
    'listOrigins': state.manageOrders.listOrigins,
    'listProviders': state.manageOrders.listProviders,
    'headerValues': state.manageOrders.headerValues,
    'originsAllData': state.manageOrders.originsAllData,
  };
};

const {setHeaderValues} = Actions;

export default connect(mapStateToProps, {
  setHeaderValues,
})(HeaderForm);
